import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-url-mapping',
  templateUrl: './url-mapping.component.html',
  styleUrls: ['./url-mapping.component.css'],
})
export class UrlMappingComponent implements OnInit {
  url: string = 'seoOffpageCampaigns';
  //url: string = 'seoKeywordDiscoveries';
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = '';

  loading: boolean = true;
  saving: boolean = false;
  actionsExpanded: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedLocation: string = 'all'; // default location
  selectedUniverse: string = 'courier'; // default universe
  selectedCategory: string = ''; // empty = all categories

  pendingLocation: string = 'all';
  pendingUniverse: string = 'courier';
  pendingCategory: string = '';

  // Unique values extracted from the loaded campaigns
  uniqueLocations: string[] = [];
  uniqueUniverses: string[] = [];
  uniqueCategories: string[] = [];

  // ── Lookup tables ─────────────────────────────────────────────────────────
  locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
    { value: 'miami_fl', label: 'Miami, FL' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  keywordIntents = [
    { value: 'high_intent_local', label: 'High-Intent Local' },
    { value: 'broad_commercial', label: 'Broad Commercial' },
    { value: 'mixed_high_intent', label: 'Mixed High-Intent' },
    { value: 'informational', label: 'Informational' },
    { value: 'navigational', label: 'Navigational' },
    { value: 'brand_intent', label: 'Brand Intent' },
  ];

  // ── Loaded data ───────────────────────────────────────────────────────────
  /** All approved campaigns fetched from the API */
  allCampaigns: any[] = [];

  /** Currently selected (active) campaign after filter match */
  campaign: any = null;

  /** Active campaign _id – used when saving keyword changes */
  campaignId: string = '';

  // ── Derived view data ─────────────────────────────────────────────────────
  stats = {
    mappedKeywords: { value: 0, trend: '', up: true },
    mappedPages: { value: 0, trend: '', up: true },
    unmappedHighValue: { value: 0, trend: '', up: false },
    cannibalizationIssues: { value: 0, trend: '', up: false },
    mappingGaps: { value: 0, text: '' },
  };

  mappings: any[] = [];

  // Selected item for right-side panel
  selectedMapping: any = {
    keyword: '',
    status: '',
    tags: [],
    primaryUrlCandidate: '',
    architecturalFit: '',
    semanticCoverage: '',
    explicitIntentSupport: '',
    cannibalizationRisk: '',
    technicalEligibility: '',
    contentDepth: '',
    currentRankingUrl: '',
    mappingDivergence: '',
    aiRationale: '',
    _index: -1,
  };

  // Decision center form state
  decisionUrl: string = '';
  decisionNote: string = '';

  // ── Static UI-only widgets ────────────────────────────────────────────────
  highValueKeywords = [
    {
      keyword: 'miami to orlando courier',
      oppScore: 92,
      intent: 'Transactional',
      action: 'Create New Url',
    },
    {
      keyword: 'business courier miami',
      oppScore: 88,
      intent: 'Commercial',
      action: 'Create New Url',
    },
    {
      keyword: 'overnight courier miami',
      oppScore: 85,
      intent: 'Transactional',
      action: 'Review Architecture',
    },
    {
      keyword: 'law firm messenger miami',
      oppScore: 80,
      intent: 'Commercial',
      action: 'Create New Url',
    },
    {
      keyword: 'medical specimen courier miami',
      oppScore: 78,
      intent: 'Transactional',
      action: 'Create New Url',
    },
  ];

  cannibalizationIssuesList = [
    {
      primaryUrl: '/legal-services/',
      competingUrl: '/courier-services/',
      overlap: 18,
      severity: 'High',
    },
    {
      primaryUrl: '/same-day-courier/',
      competingUrl: '/rush-courier-service/',
      overlap: 12,
      severity: 'Medium',
    },
    {
      primaryUrl: '/medical-courier/',
      competingUrl: '/healthcare-courier/',
      overlap: 9,
      severity: 'Medium',
    },
    {
      primaryUrl: '/task-runner-services/',
      competingUrl: '/runner-services/',
      overlap: 7,
      severity: 'Low',
    },
  ];

  orphanPages = [
    {
      page: '/old-courier-services/',
      inIndex: 'Yes',
      backlinks: 2,
      status: 'Orphan',
    },
    {
      page: '/discount-courier/',
      inIndex: 'Yes',
      backlinks: 1,
      status: 'Orphan',
    },
    { page: '/temp-delivery/', inIndex: 'No', backlinks: 0, status: 'Orphan' },
    {
      page: '/legacy-routes-miami/',
      inIndex: 'Yes',
      backlinks: 0,
      status: 'Orphan',
    },
  ];

  signals = [
    {
      title: 'Explicit Intent Support Weak',
      to: 'ON-PAGE',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Primary URL Needs Internal Support',
      to: 'INTERNAL LINKS',
      status: 'Sent',
      date: 'May 18',
    },
    {
      title: 'Technical Eligibility Review',
      to: 'TECHNICAL QA',
      status: 'Open',
      date: 'May 18',
    },
  ];

  recentActivity = [
    {
      action: 'Primary URL Assigned',
      details: 'same day courier miami -> /same-day-courier/',
      by: 'AI',
      date: 'May 18',
    },
    {
      action: 'Supporting URL Added',
      details: 'court filing courier miami -> /legal-services/',
      by: 'Felipe',
      date: 'May 17',
    },
    {
      action: 'Mapping Updated',
      details: 'rush legal courier service role changed to Supporting',
      by: 'AI',
      date: 'May 16',
    },
    {
      action: 'New URL Proposed',
      details: 'miami to orlando courier -> /routes/miami-to-orlando-courier/',
      by: 'AI',
      date: 'May 15',
    },
  ];

  filteredData: Array<any> = [];
  hasSearched: boolean = false;
  data: Array<any> = [];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  // ── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.loadCampaigns();
    this.getData();
  }

  // ── Data loading ──────────────────────────────────────────────────────────
  /**
   * Fetches ALL approved campaigns (no id in url).
   * After loading, derives unique filter values and auto-selects
   * the first campaign that matches the default location/universe.
   */
  loadCampaigns(): void {
    this.loading = true;

    // Build query params: only approved, no page limit needed for filtering
    const params = `?status=approved&limit=200`;

    this.dataService.getData(`${this.url}${params}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.allCampaigns = response.data;
          this.extractUniqueFilterValues();
          this.applyFilterAndSelect();
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaigns',
            'danger',
          );
          this.loading = false;
        }
      },
      (_err: any) => {
        this.messageService.add('Could not connect to the server.', 'danger');
        this.loading = false;
      },
    );
  }

  /** Pull distinct location / universe / category values from all loaded campaigns */
  extractUniqueFilterValues(): void {
    const locSet = new Set<string>();
    const uniSet = new Set<string>();
    const catSet = new Set<string>();

    this.allCampaigns.forEach((c: any) => {
      if (c.location) locSet.add(c.location);
      if (c.universe) uniSet.add(c.universe);
      if (c.category) catSet.add(c.category);
    });

    this.uniqueLocations = Array.from(locSet).sort();
    this.uniqueUniverses = Array.from(uniSet).sort();
    this.uniqueCategories = Array.from(catSet).sort();

    // If default selectedLocation is not present in data, fall back to first available
    if (
      this.uniqueLocations.length &&
      !this.uniqueLocations.includes(this.selectedLocation)
    ) {
      this.selectedLocation = this.uniqueLocations[0];
      this.pendingLocation = this.selectedLocation;
    }
    if (
      this.uniqueUniverses.length &&
      !this.uniqueUniverses.includes(this.selectedUniverse)
    ) {
      this.selectedUniverse = this.uniqueUniverses[0];
      this.pendingUniverse = this.selectedUniverse;
    }
  }

  /**
   * Filters allCampaigns by the active filter selections and
   * picks the first matching campaign to display its keyword mappings.
   */
  applyFilterAndSelect(): void {
    const matched = this.allCampaigns.filter((c: any) => {
      const locMatch =
        !this.selectedLocation || c.location === this.selectedLocation;
      const uniMatch =
        !this.selectedUniverse || c.universe === this.selectedUniverse;
      const catMatch =
        !this.selectedCategory || c.category === this.selectedCategory;
      return locMatch && uniMatch && catMatch;
    });

    if (matched.length === 0) {
      this.campaign = null;
      this.campaignId = '';
      this.mappings = [];
      this.resetStats();
      this.loading = false;
      return;
    }

    // Use the first matched campaign (best-fit)
    this.campaign = matched[0];
    this.campaignId = matched[0]._id;
    this.buildMappings();
    this.buildStats();
    this.loading = false;
  }

  /** Called whenever a filter dropdown changes */
  onFilterChange(): void {
    this.selectedLocation = this.pendingLocation;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedCategory = this.pendingCategory;

    this.selectedMapping = { ...this.selectedMapping, _index: -1 };
    this.applyFilterAndSelect();
  }

  // ── Mappings builder ──────────────────────────────────────────────────────
  buildMappings(): void {
    const keywords = this.campaign?.keywords || [];
    const intentLabel = this.getIntentLabel(this.campaign?.keywordIntent || '');

    this.mappings = keywords.map((kw: any, index: number) => {
      const hasUrl = kw.url && kw.url.trim();
      const mappingStatus = !hasUrl
        ? 'Unmapped'
        : kw.status === 'paused'
          ? 'Needs Review'
          : 'Mapped';

      return {
        index,
        keyword: kw.value || '',
        searchIntent: intentLabel || 'Commercial',
        primaryUrl: hasUrl ? kw.url.trim() : '-',
        urlRole: hasUrl ? 'Primary' : '-',
        architectureFit: hasUrl ? 'Mappable' : 'Needs New URL',
        semanticCoverage: hasUrl ? 'Strong' : '-',
        explicitIntentSupport: hasUrl ? 'Moderate' : '-',
        mappingStatus,
        keywordStatus: kw.status,
      };
    });

    // Auto-select first mapped item, or first overall
    const firstMapped = this.mappings.find((m) => m.mappingStatus === 'Mapped');
    const toSelect = firstMapped || this.mappings[0];
    if (toSelect) {
      this.selectMapping(toSelect);
    }
  }

  buildStats(): void {
    const keywords = this.campaign?.keywords || [];
    const mapped = keywords.filter((kw: any) => kw.url && kw.url.trim());
    const unmapped = keywords.filter((kw: any) => !kw.url || !kw.url.trim());
    const uniqueUrls = new Set(
      keywords.map((kw: any) => kw.url).filter(Boolean),
    );

    this.stats = {
      mappedKeywords: {
        value: mapped.length,
        trend: `${keywords.length} total keywords`,
        up: mapped.length >= unmapped.length,
      },
      mappedPages: {
        value: uniqueUrls.size,
        trend: 'unique URLs assigned',
        up: uniqueUrls.size > 0,
      },
      unmappedHighValue: {
        value: unmapped.length,
        trend: `${unmapped.length} without URL`,
        up: false,
      },
      cannibalizationIssues: {
        value: this.cannibalizationIssuesList.length,
        trend: 'detected issues',
        up: false,
      },
      mappingGaps: {
        value: this.needsReviewCount,
        text: this.needsReviewCount > 0 ? 'Need review' : 'All clear',
      },
    };
  }

  resetStats(): void {
    this.stats = {
      mappedKeywords: { value: 0, trend: 'No campaign loaded', up: false },
      mappedPages: { value: 0, trend: '', up: false },
      unmappedHighValue: { value: 0, trend: '', up: false },
      cannibalizationIssues: { value: 0, trend: '', up: false },
      mappingGaps: { value: 0, text: 'No campaign matched' },
    };
  }

  // ── Selection & Decision Center ───────────────────────────────────────────
  selectMapping(m: any): void {
    this.selectedMapping = {
      keyword: m.keyword,
      status: m.mappingStatus === 'Mapped' ? 'Approved' : m.mappingStatus,
      tags: [m.searchIntent, m.urlRole !== '-' ? m.urlRole : ''].filter(
        Boolean,
      ),
      primaryUrlCandidate: m.primaryUrl !== '-' ? m.primaryUrl : 'Not assigned',
      architecturalFit: m.architectureFit,
      semanticCoverage: m.semanticCoverage,
      explicitIntentSupport: m.explicitIntentSupport,
      cannibalizationRisk: 'Low',
      technicalEligibility: 'Eligible',
      contentDepth: 'Moderate',
      currentRankingUrl: m.primaryUrl !== '-' ? m.primaryUrl : '-',
      mappingDivergence: m.primaryUrl !== '-' ? 'None' : 'Detected',
      aiRationale:
        m.primaryUrl !== '-'
          ? `The keyword "${m.keyword}" is mapped to ${m.primaryUrl}. Review semantic fit and intent alignment to confirm this URL is the best primary owner.`
          : `The keyword "${m.keyword}" has no URL assigned. Consider creating a dedicated landing page or mapping it to the most semantically relevant existing URL.`,
      _index: m.index,
    };
    this.decisionUrl = m.primaryUrl !== '-' ? m.primaryUrl : '';
    this.decisionNote = '';
  }

  approveMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = this.decisionUrl.trim();
    keywords[this.selectedMapping._index].status = 'active';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping approved and saved.', 'success');
            this.buildMappings();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error saving mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  rejectMapping(): void {
    if (this.selectedMapping._index < 0 || !this.campaignId) return;

    const keywords = JSON.parse(JSON.stringify(this.campaign?.keywords || []));
    if (!keywords[this.selectedMapping._index]) return;

    keywords[this.selectedMapping._index].url = '';
    keywords[this.selectedMapping._index].status = 'paused';

    this.saving = true;
    this.dataService
      .putData(`${this.url}/edit/${this.campaignId}`, { keywords })
      .subscribe(
        (response: any) => {
          this.saving = false;
          if (response.rst) {
            this.campaign.keywords = keywords;
            this.messageService.add('Mapping rejected.', 'info');
            this.buildMappings();
            this.buildStats();
          } else {
            this.messageService.add(
              response.msg || 'Error rejecting mapping',
              'danger',
            );
          }
        },
        (_err: any) => {
          this.saving = false;
          this.messageService.add('Server error while saving.', 'danger');
        },
      );
  }

  // ── Computed getters ──────────────────────────────────────────────────────
  get mappedCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Mapped').length;
  }

  get unmappedCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Unmapped').length;
  }

  get needsReviewCount(): number {
    return this.mappings.filter((m) => m.mappingStatus === 'Needs Review')
      .length;
  }

  // ── Label helpers ─────────────────────────────────────────────────────────
  getIntentLabel(value: string): string {
    return this.keywordIntents.find((k) => k.value === value)?.label || value;
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response ', response);
        if (response.data) {
          this.data = response.data
            .filter((item: any) => item.status === 'approved')
            .sort((a: any, b: any) => {
              return (
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
              );
            });
          this.filteredData = [...this.data];
          this.filter();
        }
      });
  }

  filter() {
    this.hasSearched = true;
    this.calculatePortfolioStats();
  }

  calculatePortfolioStats() {
    const allKws: any[] = [];
    this.filteredData.forEach((item: any) => {
      this.getKeywords(item).forEach((kw: any) => allKws.push(kw));
    });

    const total = allKws.length;
    const active = allKws.filter((k) => k.status === 'active').length;
    const banked = allKws.filter((k) => k.status === 'banked').length;
    const review = allKws.filter((k) => k.status === 'review').length;
    const archived = allKws.filter((k) => k.status === 'disabled').length;

    const pct = (n: number) =>
      total > 0 ? Math.round((n / total) * 1000) / 10 : 0;

    // Average days since last check
    const now = Date.now();
    const kwsWithDate = allKws.filter((k) => k.lastCheck);
    const avgDays =
      kwsWithDate.length > 0
        ? Math.round(
            kwsWithDate.reduce((acc, k) => {
              const diff = now - new Date(k.lastCheck).getTime();
              return acc + diff / (1000 * 60 * 60 * 24);
            }, 0) / kwsWithDate.length,
          )
        : 0;
  }

  getKeywords(item: any): any[] {
    if (!item || !Array.isArray(item.keywords)) return [];

    // Use cached processed keywords if available to prevent constant DOM rebuilding
    if (item._processedKeywords) {
      return item._processedKeywords;
    }

    // Mock ranking data pool mirroring the reference image
    const mockPool = [
      {
        currentPos: 8,
        prevPos: 10,
        change: 2,
        trend: 'improving',
        oppRank: '#1 / 15',
        searchVolume: '1.9k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 14,
        prevPos: 12,
        change: -2,
        trend: 'improving',
        oppRank: '#2 / 15',
        searchVolume: '2.4k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 18,
        prevPos: 21,
        change: 3,
        trend: 'improving',
        oppRank: '#4 / 15',
        searchVolume: '1.1k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 27,
        prevPos: 29,
        change: 2,
        trend: 'stable',
        oppRank: '#9 / 15',
        searchVolume: '720',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 41,
        prevPos: 34,
        change: -7,
        trend: 'declining',
        oppRank: '#12 / 15',
        searchVolume: '590',
        lastCheck: '2026-06-15',
      },
      {
        currentPos: 16,
        prevPos: 16,
        change: 0,
        trend: 'stable',
        oppRank: '#5 / 15',
        searchVolume: '1.3k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 23,
        prevPos: 25,
        change: 2,
        trend: 'improving',
        oppRank: '#6 / 15',
        searchVolume: '880',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 35,
        prevPos: 28,
        change: -7,
        trend: 'declining',
        oppRank: '#11 / 15',
        searchVolume: '480',
        lastCheck: '2026-06-30',
      },
      {
        currentPos: 52,
        prevPos: 48,
        change: -4,
        trend: 'declining',
        oppRank: '#15 / 15',
        searchVolume: '390',
        lastCheck: '2026-06-30',
      },
      {
        currentPos: 12,
        prevPos: 13,
        change: 1,
        trend: 'improving',
        oppRank: '#3 / 15',
        searchVolume: '1.6k',
        lastCheck: '2026-07-01',
      },
    ];

    const processed = item.keywords
      .map((kw: any, index: number) => {
        const mock = mockPool[index % mockPool.length];
        return {
          value: kw.value,
          status: kw.status || 'active',
          url: kw.url,
          field: 'keywords',
          index: index,
          currentPos: kw.currentPos ?? mock.currentPos,
          prevPos: kw.prevPos ?? mock.prevPos,
          change: kw.change ?? mock.change,
          trend: kw.trend ?? mock.trend,
          oppRank: kw.oppRank ?? mock.oppRank,
          searchVolume: kw.searchVolume ?? mock.searchVolume,
          lastCheck: kw.lastCheck ?? mock.lastCheck,
        };
      })
      .filter((kw: any) => kw.value);

    // Cache the result
    item._processedKeywords = processed;
    return processed;
  }

  getLastCheckStatus(lastCheck: string | Date): 'fresh' | 'due' {
    if (!lastCheck) return 'due';
    const checkDate = new Date(lastCheck);
    const diffMs = Date.now() - checkDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays <= 7 ? 'fresh' : 'due';
  }

  changeKeywordStatus(item: any, kw: any, newStatus: string): void {
    const statusMsg =
      newStatus === 'active'
        ? 'activar'
        : newStatus === 'paused'
          ? 'pausar'
          : 'deshabilitar';
    if (!confirm(`¿Desea ${statusMsg} la keyword "${kw.value}"?`)) {
      return;
    }

    const payload = {
      field: kw.field || 'keywords',
      index: kw.index,
      status: newStatus,
    };

    this.dataService
      .putData(`${this.url}/${item._id}/item-status`, payload)
      .subscribe({
        next: (response) => {
          if (response.rst) {
            this.messageService.add('Estado actualizado correctamente', 'info');
            // Actualizar localmente el status para no recargar todo
            kw.status = newStatus;
            // También actualizar en el objeto original item por si acaso
            if (item.keywords && item.keywords[kw.index]) {
              item.keywords[kw.index].status = newStatus;
            }
          } else {
            this.messageService.add(response.msg, 'secondary');
          }
        },
        error: (err) => {
          console.error('Error updating keyword status:', err);
          this.messageService.add('Error al actualizar el estado', 'danger');
        },
      });
  }

  deleteKeyword(item: any, kw: any) {
    if (
      !confirm(
        `¿Estás seguro de que deseas eliminar permanentemente la keyword "${kw.value}"?`,
      )
    ) {
      return;
    }

    const payload = {
      field: kw.field || 'keywords',
      index: kw.index,
    };

    this.dataService
      .putData(`${this.url}/${item._id}/item-remove`, payload)
      .subscribe({
        next: (response) => {
          if (response.rst) {
            this.messageService.add(
              'Keyword eliminada correctamente',
              'success',
            );
            this.getData();
          } else {
            this.messageService.add('Error: ' + response.msg, 'secondary');
          }
        },
        error: (err) => {
          console.error('Error deleting keyword:', err);
          this.messageService.add('Error al eliminar keyword', 'danger');
        },
      });
  }
}
